import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import { TdsLoadingSpinner } from "@trv-tds/react";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { oktaConfig } from "./config/oktaConfig";
import { SecureRoute } from "./components/SecureRoute/SecureRoute.tsx";
import { LoginCallback } from "./pages/LoginCallback/LoginCallback.tsx";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary.tsx";

const App = lazy(() => import("./App.tsx"));
const Home = lazy(() => import("./pages/Home/Home.tsx"));

const oktaAuth = new OktaAuth(oktaConfig);

function Router() {
  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri: string
  ) => {
    globalThis.location.replace(
      toRelativeUrl(originalUri || "/", globalThis.location.origin)
    );
  };

  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <ErrorBoundary>
          <Suspense fallback={<TdsLoadingSpinner centered label="Loading" />}>
            <Routes>
              <Route path="/login/callback" element={<LoginCallback />} />
              <Route element={<SecureRoute />}>
                <Route path="/" element={<App />}>
                  <Route index element={<Home />} />
                </Route>
              </Route>
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </Security>
    </BrowserRouter>
  );
}

export default Router;
